module.exports = __webpack_public_path__ + "img/smartEnergy-lg.0ac34632.jpg";